module.exports = __webpack_public_path__ + "img/某市公安教育的发展与改革.5693786b.png";